export default function storageUnit() {}

/**
 * 将存储大小转为kb;
 * 示例: `storageUnit.toKb(1GB)` => 1048576
 * @param {string} [val='']
 * @return {*} 
 */
storageUnit.toKb = function(val = '') {
    let count = parseFloat(val)
    val = val.toLocaleLowerCase()

    if(/gb?$/.test(val)) {
        count *= 1024
        val = val.replace(/gb?$/, 'm')
    }
    
    if(/mb?$/.test(val)) {
        count *= 1024
        val.replace(/mb?$/, 'k')
    }

    return count
}

/**
 * 将存kb转为对应单位;
 * 示例: `storageUnit.toString(1629)` => 1.59MB
 * @param {*} kb
 * @return {*} 
 */
storageUnit.toString = function(kb) {
    let val = parseFloat(kb)

    // 大于1G
    if(val > 1024 * 1024) {
        val = parseFloat((val / 1024 / 1024).toFixed(2)) + 'GB'
    // 大于1M
    }else if(val > 1024) {
        val = parseFloat((val / 1024).toFixed(2)) + 'MB'
    // KB
    }else {
        val = parseFloat(val.toFixed(2)) + 'KB'
    }
    
    return val
}
